export const isVersionNewer = (
  currentVersion: string,
  targetVersion: string,
): boolean => {
  const currentParts = currentVersion.split(".").map(Number);
  const targetParts = targetVersion.split(".").map(Number);

  for (let i = 0; i < Math.max(currentParts.length, targetParts.length); i++) {
    const currentPart = currentParts[i] || 0;
    const targetPart = targetParts[i] || 0;

    if (currentPart > targetPart) {
      return true;
    } else if (currentPart < targetPart) {
      return false;
    }
  }

  return false;
};
